import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux'; // ✅ import Provider
import store from './redux/store'; // ✅ import your JS store
import './locales/i18n';

if (window.location.hostname === 'rem-seeward.firebaseapp.com')
  window.location.replace('https://rem-seeward.web.app' + window.location.pathname + window.location.search);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}> {/* ✅ wrap the app */}
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);
